<template>
  <div v-if="loading"
       class="circular-loader">
    <base-circular-loader color="primary"
                          size="medium" />
  </div>

  <div v-else
       class="location-history-mobile">
    <children-map ref="map"
                  mode="profile"
                  :location="location" />

    <ul class="list">
      <li v-for="(location, index) in filteredLocations"
          :key="index"
          :class="{ selected: isActive(index) }"
          class="location"
          @click="onLocationClick(location, index)">

        <location-item :location="location"
                       :child-id="childId"
                       :head="index === 0" />
      </li>
    </ul>
  </div>
</template>

<script>
  import ChildrenMap from '@/components/Map/Map.vue'
  import LocationItem from '@/components/Child/ChildTabs/TabLocation/LocationHistoryItem.vue'

  export default {
    components: {
      ChildrenMap,
      LocationItem
    },

    props: {
      childId: {
        required: true
      }
    },

    data() {
      return {
        child: null,
        primaryDevice: null,
        locations: null,
        selectedItemIndex: null,
        loading: true
      }
    },

    created() {
      this.child = this.getChildById(this.childId)
      this.primaryDevice = this.getChildPrimaryDevice(this.childId)
      this.getLocations()
    },

    methods: {
      getLocations() {
        this.$store.dispatch('geofence/loadAggregatedLocations', this.primaryDevice.id).then(data => {
          this.locations = data
          this.loading = false
        })
      },

      onLocationClick(location, index) {
        this.selectedItemIndex = index
        this.$refs.map.createLocationTooltip({
          latitude: location.latitude,
          longitude: location.longitude,
          address: location.address,
          deviceName: this.deviceName,
          track_date: location.end_time
            ? location.end_time
            : location.start_time
        })
      },

      isActive(index) {
        return this.selectedItemIndex === index
      }
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById',
        getChildPrimaryDevice: 'getPrimaryDevice'
      }),

      location() {
        return {
          ...this.child.location,
          deviceName: this.primaryDevice.name,
          devicePlatform: this.primaryDevice.platform
        }
      },

      ...mapGetters('geofence', {
        namedLocations: 'getNamedLocations'
      }),

      namedLocationsIds() {
        return this.namedLocations.map(location => location.id)
      },

      filteredLocations() {
        return this.locations.filter(location => {
          return location.address || this.namedLocationsIds.includes(location.named_location_id)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .location-history-mobile {
    flex: 1 0;
    height: 70%;
    position: relative;

    .list {
      list-style-type: none;
      height: 42%;
      width: 100%;
      overflow: auto;
      padding: 0;
      margin: 0;

      .location {
        cursor: pointer;
        width: 100%;
        height: auto;
        
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        background: #fff;
        box-sizing: border-box;
        border-bottom: 1px solid #f2f2f2;
        opacity: .7;

        &:hover {
          opacity: 1;
          background: color.adjust(map.get($colors, primary), $lightness: 40%);

          .address,
          .time {
            opacity: 1;
          }
        }
      }

      .selected {
        background:  color.adjust(map.get($colors, primary), $lightness: 40%);

        .address,
        .time {
          opacity: 1;
        }
      }
    }
  }

  .circular-loader {
    min-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px 0;
  }
</style>